export default __webpack_public_path__ + "static/media/Heart_Hex.eaee9317.svg";